// Importar desde 'umi' y NO desde '@umijs/max': solo 'umi' está aliaseado a
// '@@/exports', donde `history` es un live binding que Umi asigna al arrancar.
// '@umijs/max' resuelve a un módulo CommonJS que congela el valor en el require,
// y como este archivo lo cargan los modelos durante el arranque, quedaría
// `undefined` y `history.push` explotaría.
import { history } from 'umi';

/**
 * Redirige a la pantalla de "no encontrado" ante un error de request.
 *
 * Los errores 5xx quedan excluidos a propósito: de esos ya se encarga el
 * interceptor de `umi-request`, que lleva a `/500`. Sin esta guarda el push a
 * '/404' se ejecutaría después del interceptor y lo pisaría, con lo cual un
 * error del servidor se vería como si el recurso no existiera.
 *
 * El resto de los casos (404, 400, timeouts, caídas de red) mantienen el
 * comportamiento previo y van a '/404'.
 */
export function redirectNotFound(error?: unknown): void {
  if (isServerError(error)) return;

  history.push('/404');
}

/**
 * True si el error viene de una respuesta 5xx del backend. Sirve para los casos
 * en que la redirección no se hace con `history` sino al renderizar
 * (`<Navigate to="/404" />`), donde igual hay que dejar pasar el /500.
 */
export function isServerError(error?: unknown): boolean {
  const err = error as { status?: number; response?: { status?: number } } | undefined;
  const status = err?.status ?? err?.response?.status;

  return typeof status === 'number' && status >= 500;
}
